import React from 'react';

/**
 * Tiny inline chip that surfaces which Defera Capital payment processor a
 * cart or booking is bound to. Renders nothing when the booking is not on
 * the NMI track — keeps the Stripe-default UI completely unchanged.
 *
 * Drop next to existing payment-method labels in admin Carts / EditCart /
 * Accounting / Past-Due pages. The processor is read from the snapshot the
 * cart/booking already carries (`flight_data._payment_processor`) so this
 * component is pure render — no extra API calls.
 */
export default function PaymentProcessorBadge({ flightData, className = '' }) {
  const processor = flightData?._payment_processor;
  if (processor !== 'nmi') return null;
  return (
    <span
      title="This booking is on the NMI / Vector Payments processor track. Installments are charged daily by our cron against a stored Customer Vault id."
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-normal tracking-wide uppercase bg-amber-500/15 text-amber-300 border border-amber-500/30 ${className}`}
    >
      NMI
    </span>
  );
}
